import React, {useState} from 'react';
import {connect} from 'react-redux';
import {CircularProgress, IconButton, Tooltip} from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import {buildSlideStitchManifest} from '../../../redux_actions/maps.state.action';
import {isCloud} from '../../../utils/utils';

/** Sits in the toolbar left of the minimap toggle. `stitchManifest` is null once loading found no manifest. */
const BuildManifestButton = ({mapId, slide, canBuild, dispatch}) => {
    const [building, setBuilding] = useState(false);
    if (!canBuild || slide?.stitchManifest !== null || isCloud()) return null;

    const build = () => {
        setBuilding(true);
        dispatch(buildSlideStitchManifest(mapId, slide)).finally(() => setBuilding(false));
    };

    return (
        <Tooltip title="Build stitch manifest (stops requests for missing tiles)" placement="left">
            <span>
                <IconButton
                    onClick={build}
                    disabled={building}
                    size="small"
                    sx={{
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        border: '2px solid #333',
                        borderRadius: '6px',
                        padding: '4px',
                        '&:hover': {backgroundColor: 'rgba(230,230,230,0.95)'},
                    }}
                >
                    {building
                        ? <CircularProgress size={18}/>
                        : <BuildIcon sx={{fontSize: 18, color: '#333'}}/>}
                </IconButton>
            </span>
        </Tooltip>
    );
};

const mapStateToProps = (state) => ({
    canBuild: !!state.osdViewerConfigReducer?.permissions?.can_build_manifest,
});

export default connect(mapStateToProps)(BuildManifestButton);
